import apiInfraction from "../axios/apiInfraction";
import GeneralFunctions from "../helpers/generalFunctions";

class StateTransitionService {
  static async changeStateInfraction(body) {
    try {
      const response = await apiInfraction.post(
        `/states-infraction/judge`,
        body
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async updateNotification(stateId, filesCode) {
    try {
      const body = {
        stateId: stateId,
        filesCode: filesCode,
      };
      const response = await apiInfraction.put(
        `/states-infraction/update-notification`,
        body
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async createDischargeProcedure(infraction) {
    const body = {
      infractionId: infraction.id,
      uuid: infraction.filesCodeAux,
      comment: infraction.comment,
      filesURL: [],
    };
    try {
      if (infraction.filesToUp?.length > 0) {
        const filesUrls = await GeneralFunctions.saveFilesOnInfractionsAPI(
          infraction.filesToUp,
          infraction.filesCodeAux
        );
        if (!filesUrls.success)
          return {
            success: false,
            message: "Error al subir los archivos, intentelo nuevamente.",
          };
        body.filesURL = filesUrls.urls;
      }
      const response = await apiInfraction.post(
        `/states-infraction/discharge`,
        body
      );
      if (response.status < 300) {
        return {
          success: true,
          data: ` El id del tramite de descargo vinculado es ${response.data.tramiteId}.`,
        };
      }
      return {
        success: false,
        message: response?.data?.message,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message ?? "",
        status: error.response?.status || 500,
      };
    }
  }

  static async unarchiveInfraction(id) {
    try {
      const body = {
        id: id,
      };
      const response = await apiInfraction.post(
        `/states-infraction/unarchive`,
        body
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  //si uso este formato no seria transaccional la creacion de la sentencia y el cambio de estado, esperar a revisar como tendria que ser el modal de sentencia
  static async createSentence(infraction) {
    const infra = infraction;
    const body = {
      sentenceId: infra.bodyTransition.optionId ?? 1,
      infractionId: infra.id,
      filesCode: infra.filesCodeAux,
      comment:
        infra.bodyTransition.comment?.legnth > 0
          ? infra.bodyTransition.comment
          : infra.bodyTransition.message,
      message:
        infra.bodyTransition.comment?.legnth > 0
          ? infra.bodyTransition.comment
          : infra.bodyTransition.message,
      cidi: infra.bodyTransition.cidi,
      subtittle: infra.bodyTransition.subtittle,
      tryCidi: infra.bodyTransition.tryCidi,
    };
    try {
      if (infraction.filesToUp?.length > 0) {
        const filesUrls = await GeneralFunctions.saveFilesOnInfractionsAPI(
          infraction.filesToUp,
          infraction.filesCodeAux
        );
        if (!filesUrls.success)
          return {
            success: false,
            message: "Error al subir los archivos, intentelo nuevamente.",
          };
      }
      const response = await apiInfraction.post(
        `/states-infraction/sentence`,
        body
      );
      if (response.status < 300) {
        return {
          success: true,
          //deben tener este atributo si es que termina y hace el paso de estado la misma funcion
          finished: true,
        };
      }
      return {
        success: false,
        message: response?.data?.message,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message ?? "",
        status: error.response?.status || 500,
      };
    }
  }
}

export default StateTransitionService;
